module.exports = __webpack_public_path__ + "img/black-collection.f03ed315.svg";